import {Experiment} from 'api/experiments/experiments.types';

/**
 * Experiment keys
 * Define the experiments available from our backend API.
 */
export const EXPERIMENTS = {
    rateGuidance: 'rate_guidance',
} as const;

/**
 * Determine if the Rate Guidance experiment is active for this user
 */
export const isRateGuidanceActive = (experiments: Experiment[]) => {
    const experimentStatus = 'active';

    return experiments.some(
        (experiment) =>
            experiment.name === EXPERIMENTS.rateGuidance &&
            experiment.status === experimentStatus
    );
};

/**
 *  Check if an array of facilities matches the Rate Guidance experiment's facility IDs
 */
export const hasMatchingRateGuidanceFacility = (
    experiments: Experiment[],
    filteredFacilities: number[]
): boolean => {
    const rateGuidanceExperiment = experiments.find(
        (experiment) => experiment.name === EXPERIMENTS.rateGuidance
    );

    const facilityIds = rateGuidanceExperiment?.parameters?.facilityIds ?? [];

    return filteredFacilities.some((facilityId) =>
        facilityIds.includes(Number(facilityId))
    );
};
